<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="12">
            <v-tabs centered>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-bullhorn</v-icon> Pengumuman
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassworkDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-clipboard-check</v-icon> Tugas
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclasspeopleDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-account-multiple</v-icon> Anggota
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassgradeDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-calendar-month</v-icon> Nilai
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" md="12" v-if="alertdata.show">
            <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
          </v-col>
          <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
            <v-progress-circular
              :width="3"
              color="red"
              indeterminate>
            </v-progress-circular>
          </v-col>
          <v-col cols="12" md="12">
            <v-card
              flat
              v-if="!loading.detail && detaildata.length > 0">
              <v-img
                dark
                height="260px"
                :lazy-src="require('../../assets/default.jpg')"
                :src="api + '/upload/kelas/' + detaildata[0].bgimg_class">
                <v-app-bar
                  dark
                  flat
                  color="rgba(0, 0, 0, 0)">
                  <v-toolbar-title class="text-md-h4 font-weight-bold">
                    {{ detaildata[0].nama_class ? detaildata[0].nama_class : 'Class name' }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </v-app-bar>
                <div class="px-5">
                  <div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                          @click="copyInvitecode"
                          class="cursor-style">
                          <v-icon left>mdi-qrcode-scan</v-icon>
                          <b>{{ detaildata[0].code_class ? detaildata[0].code_class : '-' }}</b>
                        </span>
                      </template>
                      <span>Klik untuk mengcopy kode</span>
                    </v-tooltip>
                    <span class="yellow--text ml-1" v-html="msgcopy"></span>
                    <input type="hidden" id="invite-elm" :value="detaildata[0].code_class">
                  </div>
                  <div>
                    <span>
                      <v-icon left>mdi-video-outline</v-icon>
                      <b>
                        <a
                          class="text-decoration-none yellow--text"
                          :href="'https://meet.google.com/lookup/PNB-' + detaildata[0].matkul_class.replace(/ /g,'_') + '-' + detaildata[0].mhs_class + '-' + getToday()"
                          target="_blank">Get google meet link
                        </a>
                      </b>
                    </span>
                  </div>
                  <div class="mt-3">
                    <div class="caption font-weight-bold">{{ detaildata[0].prodi_class }}</div>
                    <div class="caption font-weight-bold">Semester {{ detaildata[0].semester_class }}</div>
                    <div class="caption font-weight-bold">{{ detaildata[0].matkul_class }}</div>
                    <div class="caption font-weight-bold">Kelas: {{ detaildata[0].mhs_class }}</div>
                    <div class="caption font-weight-bold">Tim Teaching: {{ detaildata[0].s_kelas_tim === '1' ? 'Ya' : 'Tidak' }}</div>
                    <div class="caption font-weight-bold">T.A {{ detaildata[0].year_class }} </div>
                  </div>
                </div>
              </v-img>
              <v-card-text>
                <v-row class="black--text">
                  <v-col cols="12" md="3">
                    <h6 class="text-h6">Upcoming</h6>
                    <v-divider class="my-1"></v-divider>
                    <router-link
                      v-for="(upcom, i) in upcominglist"
                      :key="i"
                      class="link-list-style text-decoration-none"
                      :to="{ name: 'DetailposttugasDosen', query: { post: upcom.id_post, class: detaildata[0].id_class } }">
                      <div
                        class="item-list-style py-2">
                        <div class="text-caption">Due {{ upcom.duedate_post }}</div>
                        <div class="text-subtitle-1">{{ upcom.title_post }}</div>
                      </div>
                    </router-link>
                    <div v-if="upcominglist.length <= 0" class="grey--text">
                      not available!
                    </div>
                  </v-col>
                  <v-col cols="12" md="9">
                    <v-card
                      v-for="(anno, i) in announcelist"
                      :key="i"
                      flat>
                      <v-card-text class="d-flex">
                        <router-link
                          v-if="anno.type_anno === 'materi'"
                          class="link-list-style text-decoration-none"
                          :to="{ name: 'DetailpostmateriDosen', query: { post: anno.id_post, class: detaildata[0].id_class } }">
                          <div class="d-flex align-center">
                            <v-btn
                              outlined
                              class="mr-2 d-inline"
                              fab
                              small
                              dark
                              color="primary">
                              <v-icon>mdi-bullhorn</v-icon>
                            </v-btn>
                            <div class="d-inline">
                              <b>{{ anno.content_anno }}</b><br>
                              <span class="text-right caption font-weight-bold">
                                {{ anno.posted_at_anno }}
                              </span>
                            </div>
                          </div>
                        </router-link>
                        <router-link
                          v-if="anno.type_anno === 'tugas'"
                          class="link-list-style text-decoration-none"
                          :to="{ name: 'DetailposttugasDosen', query: { post: anno.id_post, class: detaildata[0].id_class } }">
                          <div class="d-flex">
                            <v-btn
                              outlined
                              class="mr-2 d-inline"
                              fab
                              small
                              dark
                              color="primary">
                              <v-icon>mdi-bullhorn</v-icon>
                            </v-btn>
                            <div class="d-inline">
                              <b>{{ anno.content_anno }}</b><br>
                              <span class="text-right caption font-weight-bold">
                                {{ anno.posted_at_anno }}
                              </span>
                            </div>
                          </div>
                        </router-link>
                        <v-spacer></v-spacer>
                        <v-row
                          align="center"
                          justify="end">
                          <span class="text-right ml-2">
                            <v-menu
                              offset-y
                              bottom
                              left
                              nudge-bottom="10"
                              transition="scale-transition">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="primary"
                                  class="text-capitalize"
                                  icon
                                  v-bind="attrs"
                                  v-on="on"
                                  exact>
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-if="anno.type_anno === 'materi'"
                                  :to="{ name: 'DetailpostmateriDosen', query: { post: anno.id_post, class: detaildata[0].id_class } }">
                                  <v-list-item-title>View</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                  v-if="anno.type_anno === 'tugas'"
                                  :to="{ name: 'DetailposttugasDosen', query: { post: anno.id_post, class: detaildata[0].id_class } }">
                                  <v-list-item-title>View</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                  @click="removeAnno(anno)">
                                  <v-list-item-title>Delete</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </span>
                        </v-row>
                      </v-card-text>
                      <v-divider class="my-1"></v-divider>
                    </v-card>
                    <div v-if="announcelist.length <= 0" class="grey--text">
                      not available!
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="12">
            <div class="mt-5 text-center">
              <v-btn
                class="mr-2 mb-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'ListclassDosen' }">
                <v-icon dark>
                  mdi-arrow-left-thick
                </v-icon>
              </v-btn>
              <span class="title">Daftar kelas</span>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- remove post -->
    <v-dialog
      v-model="dmodal.ranno"
      max-width="450px">
      <v-card v-if="dmodaldata.ranno">
        <v-card-title>
          <span>Hapus pengumuman</span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.ranno = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <alertsp :alertdata="alertupdate"></alertsp>
          <div class="font-weight-bold">
            Apakah Anda yakin ingin menghapus pengumuman ini? <br>
            <b>{{ dmodaldata.ranno.content_anno }}</b>
          </div>
          <v-btn
            class="mt-4"
            small
            color="primary"
            :loading="loading.remove"
            :disabled="loading.remove"
            @click="confirmRemoveAnno(dmodaldata.ranno)">
            Hapus
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'DetailclassDosen',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
      upcoming: false,
      announce: false,
      remove: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    detaildata: [],
    upcominglist: [],
    announcelist: [],
    panduan: null,
    paramclass: {
      search: '',
      limit: '',
      offset: '',
    },
    check: {
      class: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    dmodal: {
      ranno: false,
    },
    dmodaldata: {
      ranno: null,
    },
    msgcopy: '',
  }),
  watch: {
    '$route.query.class'(val) {
      if (val) {
        this.check.class = val;
        this.getClass();
      }
    },
  },
  mounted() {
    if (this.$route.query.class && this.$route.query.class !== '') {
      this.check.class = this.$route.query.class;
      this.getClass();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    copyInvitecode() {
      this.msgcopy = '';
      const invelm = document.querySelector('#invite-elm');
      invelm.setAttribute('type', 'text');
      invelm.select();
      try {
        document.execCommand('copy');
        this.msgcopy = 'copied';
      } catch (err) {
        this.msgcopy = 'Unable to copy!';
      }
      invelm.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
      setTimeout(() => this.msgcopy = '', 7000);
    },
    getToday() {
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      const yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      today = mm + '-' + dd + '-' + yyyy;
      return today;
    },
    getClass() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.class) {
        this.axios
          .get(
            this.api + '/api/kelas/teacher/' + this.check.class,
            {
              params: this.paramclass,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                this.getAnnounce();
                this.getUpcoming();
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Kelas tidak ditemukan!';
      }
    },
    getAnnounce() {
      if (this.tokenscr) {
        this.loading.announce = true;
        this.axios
          .get(
            this.api + '/api/announce/class/' + this.check.class,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.announcelist = resdata.data;
              }
            }
            this.loading.announce = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.announce = false;
          });
      }
    },
    getUpcoming() {
      if (this.tokenscr) {
        this.loading.upcoming = true;
        this.axios
          .get(
            this.api + '/api/post/upcomming/' + this.check.class,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.upcominglist = resdata.data;
              }
            }
            this.loading.upcoming = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.upcoming = false;
          });
      }
    },
    removeAnno(item) {
      this.alertupdate.show = false;
      this.dmodal.ranno = true;
      this.dmodaldata.ranno = JSON.parse(JSON.stringify(item));
    },
    confirmRemoveAnno(item) {
      // console.log(item);
      this.alertupdate.show = false;
      if (this.tokenscr) {
        // console.log(item);
        this.loading.remove = true;
        this.axios
          .delete(
            this.api + '/api/announce/' + item.id_anno,
            {
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.dmodal.ranno = false;
                this.dmodaldata.ranno = null;
                this.getAnnounce();
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = resdata.message;
              }
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            }
            this.loading.remove = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertupdate.show = true;
            this.alertupdate.type = 'error';
            this.alertupdate.text = 'Internal services error!';
            this.loading.remove = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
